import { Button, Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { PasswordField, useSnackbar } from "@/features/ui";
// import logoUrl from "../logo.png";
import { apiClient, getErrorMessage } from "@/features/shared";
import { yupResolver } from "@hookform/resolvers/yup";

const VALIDATION_SCHEMA = Yup.object().shape({
  password: Yup.string()
    .required("Harus diisi")
    .min(8, "Panjang minimal 8 karakter"),
  passwordConfirmation: Yup.string()
    .required("Harus diisi")
    .min(8, "Panjang minimal 8 karakter")
    .test(
      "are-passwords-match",
      "Kata sandi tidak sesuai",
      function (passwordConfirmation) {
        return passwordConfirmation === this.parent.password;
      }
    ),
});

export const RenewPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = useForm({
    resolver: yupResolver(VALIDATION_SCHEMA),
  });
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const onSubmit = async ({ password, passwordConfirmation }) => {
    try {
      await apiClient.post("users/change-password", {
        password,
        passwordConfirmation,
      });
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal mengubah kata sandi"));
      return;
    }

    navigate("/home", { replace: true });
  };

  return (
    <Stack
      sx={{
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center"
      }}>
      {/* <img src={logoUrl} style={{ height: "11.625rem" }} /> */}
      <Typography variant="h5" sx={{
        paddingX: 4
      }}>
        Aksi Perubahan Password Diperlukan
      </Typography>
      <Stack
        component="form"
        noValidate
        sx={{
          mt: 6,
          width: "18.4375rem",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <PasswordField
          required
          error={Object.hasOwn(errors, "password")}
          helperText={errors.password?.message}
          id="password"
          label="Password Baru"
          register={register}
          name="password"
        />
        <PasswordField
          required
          error={Object.hasOwn(errors, "passwordConfirmation")}
          helperText={errors.passwordConfirmation?.message}
          id="password-confirmation"
          label="Ulangi Password Baru"
          register={register}
          name="passwordConfirmation"
          sx={{ mt: 2.5 }}
        />
        <Button
          loading={isSubmitting}
          variant="contained"
          sx={{ mt: 5.5 }}
          type="submit"
        >
          Ubah Password
        </Button>
      </Stack>
    </Stack>
  );
};
